<template>
	<div class="indicator-tabs-wrapper" :style="{ top: top - 1 + 'px' }" v-show="visible">
		<div class="indicator-tabs" ref="indicator">
			<div
				v-for="(item, idx) in tabs"
				@click="selectTab(idx)"
				class="tab-item"
				:class="{ cur: curIndex === idx }"
				v-sd-clk:MallItemDetailClick="{
					sku_code: car.basic.commodity_code,
					button_name: item.name,
					page: '二手车车辆详情页',
					track_sign: item.trackPoint
				}"
			>
				{{ item.name }}
			</div>
		</div>
	</div>
</template>

<script>
import sensors from '@/util/dataTrack'

export default {
	name: 'IndicatorTabs',
	props: {
		car: {
			type: Object,
			required: true
		},
		top: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			curIndex: 0,
			scrollTopNum: 0,
			tabs: [
				{
					name: '车辆信息',
					selector: '#part_car_info',
					top: null,
					bottom: null,
					trackPoint: 'aMall.b61.d64.click.MallItemDetailClick'
				},
				{
					name: '车辆实拍',
					selector: '#part_car_album',
					top: null,
					bottom: null,
					trackPoint: 'aMall.b61.d65.click.MallItemDetailClick'
				},
				{
					name: '检测报告',
					selector: '#part_report',
					top: null,
					bottom: null,
					trackPoint: 'aMall.b61.d66.click.MallItemDetailClick'
				},
				{
					name: '服务权益',
					selector: '#part_service',
					top: null,
					bottom: null,
					trackPoint: 'aMall.b61.d67.click.MallItemDetailClick'
				},
				{
					name: '更多推荐',
					selector: '#part_recommend',
					top: null,
					bottom: null,
					trackPoint: ''
				}
			]
		}
	},
	computed: {
		visible() {
			return this.scrollTopNum - this.top > 375
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	destroyed() {
		window.removeEventListener('scroll', this.onScroll)
	},
	methods: {
		onScroll() {
			const scrollTop = window.scrollY + this.top + 48

			for (let i = 0; i < this.tabs.length; i += 1) {
				if (this.tabs[i].top < scrollTop && this.tabs[i].bottom >= scrollTop) {
					this.curIndex = i
					break
				}
			}
			this.scrollTopNum = scrollTop
		},
		selectTab(idx) {
			window.scrollTo({ top: this.tabs[idx].top - this.top - 48 })
			requestAnimationFrame(() => {
				this.curIndex = idx
			})
		}
	},
	watch: {
		curIndex(idx) {
			this.$refs.indicator.childNodes[idx].scrollIntoView({ block: 'end' })
		},

		visible() {
			for (let tab of this.tabs) {
				const $dom = document.querySelector(tab.selector)
				tab.top = $dom.offsetTop
				tab.bottom = $dom.offsetTop + $dom.clientHeight
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.indicator-tabs-wrapper {
	position: fixed;
	width: 100%;
	height: 48px;
	background-color: #ffffff;
	z-index: 50;
	overflow: hidden;

	.indicator-tabs {
		width: 100%;
		height: 56px;
		display: flex;
		align-items: flex-start;
		background-color: #ffffff;
		white-space: nowrap;
		overflow: auto hidden;
		.tab-item {
			position: relative;
			height: 48px;
			display: flex;
			align-items: center;
			@include subtitle_4();
			color: $text_tertiary;

			&:first-child {
				padding-left: 20px;
			}

			&:last-child {
				padding-right: 20px;
			}

			&:not(:last-child) {
				margin-right: 30px;
			}

			&.cur {
				@include subtitle_2();
				color: #000000;
			}
		}
	}
}
</style>
